import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SpecialtyDropdown from "../shared//SpecialtyDropdown";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import $ from "jquery";

const SearchUser = ({ userSearchObj }) => {
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const navigate = useNavigate();
  const [processing, SetProcessing] = useState(false);
  const [answers, setAnswers] = useState();
  const [custObject, SetCustObject] = useState([]);
  const [orgObj, SetOrgObj] = useState([]);
  const [vendorId, SetVendorId] = useState();

    // Accessibility: Ref for modal to manage focus
  const modalRef = useRef(null);
  const lastFocusedElement = useRef(null);
  const idPrefix = "advUserSearch_";

  const setAnswer = async (questionId, answer, chck) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const SpecialFormFields = async (val) => {};
  useEffect(() => {
    if (
      userRole === "SES ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR"
    ) {
      SetVendorId(userSession.vendor_id);
      CustomerIdSet(userSession.vendor_id);
    } else {
      const temp = [];
      for (let el of sharedObject.getOrgsObj) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
    }
    const temp = [];
    if (sharedObject.vendorsObj.length > 0) {
      for (let el of sharedObject.vendorsObj) {
        el.show = true;
        temp.push(el);
      }
    }

    SetCustObject(temp);
    SetSharedObject("specialties", {});
  }, []);

  const CustomerIdSet = async (el) => {
    if (el === "") {
      SetOrgObj([]);
      return;
    }
    SetProcessing(true);
    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObject(tmp);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObj?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObj?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObj(tmp);
  };
  const AdvSearch = async () => {
    let o = {
      ...answers,
      SystemCreated: "Portal_Upload",
      SpecializationCode: sharedObject?.specialties?.code
        ? sharedObject?.specialties?.code
        : null,
      SpecializationId: sharedObject?.specialties?.id
        ? sharedObject?.specialties?.id
        : null,
    };
    userSearchObj(o);
  };
  const handleOrg = async (vl) => {
    let val = vl.split("-");
    let obj = {
      ...answers,
      ["OrganizationId"]: parseInt(val[0]),
      ["OrganizationName"]: val[1],
    };
    await setAnswers(obj);
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  // Accessibility: Trap focus in modal and restore on close
  useEffect(() => {
    const handleFocus = (e) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(e.target) &&
        $("#advUserSearchModal").hasClass("show")
      ) {
        e.stopPropagation();
        modalRef.current.focus();
      }
    };
    if ($("#advUserSearchModal").hasClass("show")) {
      lastFocusedElement.current = document.activeElement;
      setTimeout(() => {
        if (modalRef.current) {
          modalRef.current.focus();
        }
      }, 100);
      document.addEventListener("focus", handleFocus, true);
    }
    return () => {
      document.removeEventListener("focus", handleFocus, true);
    };
  }, [processing]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    $('#advUserSearchModal').modal('hide');
    // Restore focus to last focused element
    if (lastFocusedElement.current) {
      lastFocusedElement.current.focus();
    }
  };

  return (
    <div>
      <div
        className="modal fade"
        id="advUserSearchModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="adv-usersearch-modal-title"
        data-backdrop="static"
        ref={modalRef}
        aria-describedby="advUserSearchModalDesc"
        // Accessibility: Focusable for focus trap
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title spacer-inline" id="adv-usersearch-modal-title">
                Advanced Search
              </h2>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={CloseModal}
                tabIndex={0}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div id="advUserSearchModalDesc" className="sr-only">
              Use this form to search for users by various criteria. All fields are optional.
            </div>
            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  {/*Customers*/}
                  {["ADMINISTRATOR", "SES ADMINISTRATOR", "SYSTEMADMINISTRATOR"].includes(userRole) && (
                    <>
                      {/* Customer */}
                      {(userRole === "SES ADMINISTRATOR" || userRole === "SYSTEMADMINISTRATOR") && (
                        <div className="field-wrapper">
                          <label htmlFor={idPrefix + "VendorId"} className="sp-margin3">
                            Customer
                          </label>
                          <span className="filter-container dg-clr">
                            <label htmlFor={idPrefix + "VendorIdFilter"} className="sr-only">
                              Filter Customers
                            </label>
                            <input
                              id={idPrefix + "VendorIdFilter"}
                              className="form-control filter-sm"
                              type="search"
                              placeholder="Filter"
                              onChange={(el) => {
                                filterVendors(el.target.value);
                              }}
                            />
                          </span>
                          <select
                            className="form-control"
                            id={idPrefix + "VendorId"}
                            name="VendorId"
                            value={answers?.VendorId}
                            size="4"
                            onChange={(el) => {
                              CustomerIdSet(el.target.value);
                              setAnswer("VendorId", parseInt(el.target.value));
                            }}
                          >
                            <option value={0}>Select Customer</option>
                            {custObject?.map((el) => {
                              if (el.show)
                                return (
                                  <option key={el.id} value={el.id}>
                                    {el.name}
                                  </option>
                                );
                              return null;
                            })}
                          </select>
                        </div>
                      )}
                      {/* Organization */}
                      <div className="field-wrapper">
                        <label htmlFor={idPrefix + "Org"} className="sp-margin3">
                          Organization
                        </label>
                        <span className="filter-container dg-clr">
                          <label htmlFor={idPrefix + "OrgFilter"} className="sr-only">
                            Filter Organizations
                          </label>
                          <input
                            id={idPrefix + "OrgFilter"}
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            onChange={(el) => filterOrganiations(el.target.value)}
                          />
                        </span>
                        <div aria-live="polite">
                        {orgObj.length > 0 ? (
                          <select
                            className="form-control"
                            id={idPrefix + "Org"}
                            name="Organization"
                            onChange={(el) => {
                              handleOrg(el.target.value);
                            }}
                            value={answers?.Organization}
                            size="4"
                          >
                            <option value={""}>Select Organization</option>
                            {orgObj?.map((el) => {
                              if (el.show)
                                return (
                                  <option key={el.id} value={`${el.id}-${el.name}`}>
                                    {el.name}
                                  </option>
                                );
                              return null;
                            })}
                          </select>
                        ) : (
                          <div className="watermark-wrapper">
                            No Results
                          </div>
                        )}
                      </div>
                      </div>
                    </>
                  )}
                  {/*Username*/}
                  <div className="field-wrapper">
                    <label htmlFor={idPrefix + "UserName"}>Username</label>
                    <input
                      id={idPrefix + "UserName"}
                      type="text"
                      className="form-control"
                      autoComplete="username"
                      onChange={(el) => {
                        setAnswer("UserName", el.target.value);
                      }}
                      value={answers?.UserName || ""}
                    />
                  </div>
                  {/*First or Last Name*/}
                  <div className="field-wrapper spacer-margin5 spacer-inline w-md2 v-top">
                    <label htmlFor={idPrefix + "FirstName"}>First Name</label>
                    <input
                      id={idPrefix + "FirstName"}
                      type="text"
                      className="form-control"
                      autoComplete="given-name"
                      onChange={(el) => {
                        setAnswer("FirstName", el.target.value);
                      }}
                      value={answers?.FirstName || ""}
                    />
                  </div>
                  <div className="field-wrapper spacer-inline w-md2 v-top">
                    <label htmlFor={idPrefix + "LastName"}>Last Name</label>
                    <input
                      id={idPrefix + "LastName"}
                      type="text"
                      className="form-control"
                      autoComplete="family-name"
                      onChange={(el) => {
                        setAnswer("LastName", el.target.value);
                      }}
                      value={answers?.LastName || ""}
                    />
                  </div>
                  {/*Email*/}
                  <div className="field-wrapper">
                    <label htmlFor={idPrefix + "ContactEmail"}>Email</label>
                    <input
                      id={idPrefix + "ContactEmail"}
                      type="text"
                      className="form-control"
                      autoComplete="email"
                      onChange={(el) => {
                        setAnswer("ContactEmail", el.target.value);
                      }}
                      value={answers?.ContactEmail || ""}
                    />
                  </div>
                  {/*City*/}
                  <div className="field-wrapper">
                    <label htmlFor={idPrefix + "City"}>City</label>
                    <input
                      id={idPrefix + "City"}
                      type="text"
                      className="form-control"
                      autoComplete="address-level2"
                      onChange={(el) => {
                        setAnswer("City", el.target.value);
                      }}
                      value={answers?.City || ""}
                    />
                  </div>
                  {/*State and Zip*/}
                  <div className="field-wrapper">
                    <div className="field-box1 field-ext">
                      <label htmlFor={idPrefix + "State"}>State</label>
                      <select
                        className="form-control"
                        id={idPrefix + "State"}
                        name="state"
                        onChange={(el) => {
                          setAnswer("State", el.target.value);
                        }}
                        value={answers?.State || ""}
                      >
                        <option value="">Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="field-box1 field-ext">
                      <label htmlFor={idPrefix + "Zip"}>Zip</label>
                      <input
                        id={idPrefix + "Zip"}
                        className="form-control"
                        autoComplete="postal-code"
                        onChange={(el) => {
                          setAnswer("Zip", el.target.value);
                        }}
                        value={answers?.Zip || ""}
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                  </div>

                  <div className="field-wrapper">
                    <div id={idPrefix + "accordion"} className="accordion">
                      <div className="card mb-0">
                        <div
                          className="card-header collapsed"
                          data-toggle="collapse"
                          data-parent={`#${idPrefix}accordion`}
                          href={`#${idPrefix}collapseThree`}
                          id={idPrefix + "specialtyAccordionHeader"}
                          tabIndex={0}
                          role="button"
                          aria-expanded="false"
                          aria-controls={idPrefix + "collapseThree"}
                          onKeyDown={e => {
                            if (e.key === "Enter" || e.key === " ") {
                              $(`#${idPrefix}collapseThree`).collapse("toggle");
                            }
                          }}
                        >
                          <span className="sr-only">Specialty (expand/collapse)</span>
                        </div>
                        <div
                          id={idPrefix + "collapseThree"}
                          className="collapse"
                          data-parent={`#${idPrefix}accordion`}
                          aria-labelledby={idPrefix + "specialtyAccordionHeader"}
                        >
                          <div className="field-wrapper spacer-margin4">
                            <div className="ctr sub-titles spacer-margin7 blk-clr">
                              Specialty
                            </div>
                            <div className="text-reg spacer-margin7">
                              All three criteria must be selected to search by
                              Specialty.
                            </div>
                            {/*Specialty Component*/}
                            <SpecialtyDropdown
                              SpecialFormFields={SpecialFormFields}
                              codes={sharedObject.speciality?.codes}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(el) => AdvSearch()}
                  aria-label="Search"
                  aria-busy={processing}
                  disabled={processing}
                >
                  {processing ? "Searching..." : "Search"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseModal}
                  aria-label="Cancel"
                >
                  Cancel
                </button>
              </div>
                {processing && (
                    <div
                        className="loader-container"
                        role="status"
                        aria-live="polite"
                        aria-atomic="true"
                        aria-labelledby="search-user-loader"
                    >
                        <div className="spinner" aria-hidden="true"></div>
                        <div className="loading-text" id="search-user-loader">{loadingText}</div>
                    </div>
                ) }
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchUser;
